export const DELIVERY_NOTE = 'delivery_note';
export const RECEIPT_NOTE = 'receipt_note';

export const GOOGLE_PLACE_TYPES_BLACKLIST = [
  'administrative_area_level_1',
  'colloquial_area',
  'country',
  'postal_code',
  'postal_code_prefix',
  'postal_code_suffix',
  'postal_town',
];

export const PLACE_IDS_BLACKLIST = ['ChIJ0T2NLikpdTERKxE8d61aX_E'];

export const ORDER_SHARED_TRUCK_TYPE = {
  WHOLE_TRUCK: 'whole_truck',
  SHARED_TRUCK: 'shared_truck',
};

export const ORDER_TYPE = {
  ENTERPRISE: 'enterprise',
  MARKETPLACE: 'marketplace',
  ORIGINAL_HYBRID: 'original_hybrid',
};

export const BROKER_TYPE = {
  SME: 'sme',
  ENTERPRISE: 'enterprise',
};

export const BROKER_ROLES = {
  OWNER: 'owner',
  COORDINATOR: 'coordinator',
};

export const FORM_VALIDATE_STATUS = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
  VALIDATING: 'validating',
};

export const GOOGLE_AUTOCOMPLETE_KEY_NAMES = {
  FORMATTED_ADDRESS: 'formatted_address',
  DESCRIPTION: 'description',
};

export default {
  DELIVERY_NOTE,
  RECEIPT_NOTE,
  ORDER_SHARED_TRUCK_TYPE,
  GOOGLE_AUTOCOMPLETE_KEY_NAMES,
};
